import React from "react";
import { NavLink } from "react-router-dom";
import { Card } from "react-bootstrap";
import { helpTopics, categories } from "../../data/helpContent";

function HelpSidebar({ user, searchQuery }) {
  // Filter topics based on search query
  const filteredTopics = searchQuery
    ? helpTopics.filter(
        (topic) =>
          topic.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          topic.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          topic.keywords.some((keyword) =>
            keyword.toLowerCase().includes(searchQuery.toLowerCase())
          )
      )
    : helpTopics;

  // Filter out admin topics for non-admin users
  const visibleTopics = filteredTopics.filter(
    (topic) => !topic.adminOnly || user?.isAdmin || user?.isSuperUser
  );

  return (
    <Card className="sticky-top" style={{ top: "20px" }}>
      <Card.Body>
        <h5 className="mb-3">Topics</h5>
        {categories.map((category) => {
          const categoryTopics = visibleTopics.filter(
            (topic) => topic.category === category
          );

          if (categoryTopics.length === 0) return null;

          return (
            <div key={category} className="mb-4">
              <h6 className="text-muted mb-2">{category}</h6>
              <ul className="list-unstyled ms-2">
                {categoryTopics.map((topic) => (
                  <li key={topic.id} className="mb-2">
                    <NavLink
                      to={`/help/${topic.id}`}
                      className={({ isActive }) =>
                        `text-decoration-none d-block ${
                          isActive ? "text-primary fw-bold" : "text-dark"
                        }`
                      }
                    >
                      {topic.title}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </Card.Body>
    </Card>
  );
}

export default HelpSidebar;
